export const FETCH_PATIENT_QUEUE_REQUEST = "FETCH_PATIENT_QUEUE_REQUEST";
export const FETCH_PATIENT_QUEUE_SUCCESS = "FETCH_PATIENT_QUEUE_SUCCESS";
export const FETCH_PATIENT_QUEUE_FAILURE = "FETCH_PATIENT_QUEUE_FAILURE";
export const SET_SELECTED_PATIENT = "SET_SELECTED_PATIENT";

// Payment action types
export const PROCESS_PAYMENT_REQUEST = "PROCESS_PAYMENT_REQUEST";
export const PROCESS_PAYMENT_SUCCESS = "PROCESS_PAYMENT_SUCCESS";
export const PROCESS_PAYMENT_FAILURE = "PROCESS_PAYMENT_FAILURE";

// Prescription action types
export const FETCH_PRESCRIPTION_REQUEST = "FETCH_PRESCRIPTION_REQUEST";
export const FETCH_PRESCRIPTION_SUCCESS = "FETCH_PRESCRIPTION_SUCCESS";
export const FETCH_PRESCRIPTION_FAILURE = "FETCH_PRESCRIPTION_FAILURE";
export const ADD_PRESCRIPTION_REQUEST = "ADD_PRESCRIPTION_REQUEST";
export const ADD_PRESCRIPTION_SUCCESS = "ADD_PRESCRIPTION_SUCCESS";
export const ADD_PRESCRIPTION_FAILURE = "ADD_PRESCRIPTION_FAILURE";
export const UPDATE_PRESCRIPTION_REQUEST = "UPDATE_PRESCRIPTION_REQUEST";
export const UPDATE_PRESCRIPTION_SUCCESS = "UPDATE_PRESCRIPTION_SUCCESS";
export const UPDATE_PRESCRIPTION_FAILURE = "UPDATE_PRESCRIPTION_FAILURE";
export const DELETE_PRESCRIPTION_REQUEST = "DELETE_PRESCRIPTION_REQUEST";
export const DELETE_PRESCRIPTION_SUCCESS = "DELETE_PRESCRIPTION_SUCCESS";
export const DELETE_PRESCRIPTION_FAILURE = "DELETE_PRESCRIPTION_FAILURE";

export const UPDATE_PATIENT_REVIEW = "UPDATE_PATIENT_REVIEW";